import { Action, handleActions } from 'redux-actions'
import {
  getCompanyFeatureFlags,
  getCompanyFeatureFlagsSuccess,
  getCompanyFeatureFlagsFail,
  updateCompanyFeatureFlags,
  updateCompanyFeatureFlagsSuccess,
  updateCompanyFeatureFlagsFail,
} from './FeaturesAdminActions'

export interface FeatureFlag {
  key: string
  enabled: boolean
  defaultEnabled: boolean
}

class State {
  features: FeatureFlag[] = []
  loading: boolean = false
  saving: boolean = false
}

export const featuresAdmin = handleActions<State, any>(
  {
    // --- Get Feature Flags ---
    [String(getCompanyFeatureFlags)]: (state: State): State => ({
      ...state,
      loading: true,
    }),
    [String(getCompanyFeatureFlagsSuccess)]: (state: State, action: Action<any>): State => ({
      ...state,
      loading: false,
      features: action.payload?.features || [],
    }),
    [String(getCompanyFeatureFlagsFail)]: (state: State): State => ({
      ...state,
      loading: false,
      features: [],
    }),

    // --- Update Feature Flags ---
    [String(updateCompanyFeatureFlags)]: (state: State): State => ({
      ...state,
      saving: true,
    }),
    [String(updateCompanyFeatureFlagsSuccess)]: (state: State): State => ({
      ...state,
      saving: false,
    }),
    [String(updateCompanyFeatureFlagsFail)]: (state: State): State => ({
      ...state,
      saving: false,
    }),
  },
  new State(),
)

export { State as FeaturesAdminState }
